import { createContext } from 'react';
const LinkingContext = /*#__PURE__*/createContext({
  options: undefined
});
let StackActions, getStateFromPath, getActionFromState;
export { LinkingContext, StackActions, getStateFromPath, getActionFromState };